<template>
    <article class="siteEmbed">
        <div class="container">
            <iframe :src="properties.siteUrl" @click.stop></iframe>
            <button class="button__close btnfx btnfx__clickflash btnfx__hoverscale" @click="closeComponent">
                <img src="@/assets/img/ui/close.svg" />
            </button>
        </div>
    </article>

</template>


<script>

import Logo from "../../ui/Logo.vue";
export default {
    components: {
        Logo,
    },
    props: [
        "properties",
        "pageData",
        "slug"
    ],
    data() {
        return {
            ready: false,
            fullscreen: true,
        }
    },
    mounted() {

        // detect mobile devices
        function isMobileDevice() {
            return /Mobi|Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
        }

        if (isMobileDevice()) {
            window.open(this.siteUrl, '_blank');
            this.closeComponent();
            return;
        }

        this.ready = true;
    },
    methods: {
        closeComponent() {
            console.log("close");
            this.$emit("closeComponent", this.slug)
        },
        getBackgroundImage() {
            return {
                'background-image': `url(${this.getCDNpath('assets/img/ui/slideshow-bg.png')})`
            }
        },
        getCDNpath(asset) {
            return app.api.Utils.getCDNpath(asset)
        }
    },
    computed: {

        invertedScaleStyles() {
            // lets iframe content scale to always be 1! - despite any TK scale
            var currentScale = this.$store.getters.getScaleValue;
            var invertedScale = 1 / currentScale;
            var initWidth = 50;
            var initHeight = 75;
            return {
                'transform': `scale(${invertedScale})`,
                'height': `${currentScale * initHeight}%`,
                'width': `${currentScale * initWidth}%`
            }

        },
    }
};
</script>


<style lang="scss">
.siteEmbed {

    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    background-repeat: repeat;
    width: 100%;
    height: 100%;
    background-color: #000000cc;

    .container {
        width: 1000px;
        height: 650px;
        background-color: #fff;
        position: relative;
        border-radius:32px;

        &>iframe {
            border: none;
            width: 100%;
            height: 100%;
        }

        &>.button__close {
            position: absolute;
            top: 15px;
            right: 15px;
            width: 40px;
            height: 40px;
            border-radius: 50%;
            display: flex;
            justify-content: center;
            align-items: center;
       
            border: 3px solid var(--main-color-transparent);
            background-color: var(--main-color);

            img {
                width: 15px;
            }
        }
    }
}
</style>
